<template>
  <span
    v-if="code === 'en'"
    class="flag-icon flag-icon-squared"
    :class="`flag-icon-gb`"
  />
  <span
    v-else
    class="flag-icon flag-icon-squared"
    :class="`flag-icon-${code}`"
  />
</template>

<script>

export default {
    name: 'VtFlags',
    props: {
        code: { type: String }
    }
}
</script>
